const LOCAL_DEV_API_ORIGIN = 'http://127.0.0.1:8888';

/** Laravel backend origin (no /api suffix). */
function resolveApiOrigin() {
  const fromEnv = (process.env.REACT_APP_API_ORIGIN || '').trim().replace(/\/$/, '');
  const isLocalhostBuild =
    !fromEnv ||
    fromEnv === LOCAL_DEV_API_ORIGIN ||
    fromEnv.startsWith('http://127.0.0.1') ||
    fromEnv.startsWith('http://localhost');

  if (
    process.env.NODE_ENV === 'production' &&
    isLocalhostBuild &&
    typeof window !== 'undefined' &&
    window.location?.origin &&
    !/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(window.location.origin)
  ) {
    return window.location.origin.replace(/\/$/, '');
  }

  if (fromEnv) return fromEnv;
  return LOCAL_DEV_API_ORIGIN;
}

export const API_ORIGIN = resolveApiOrigin();

export const API_BASE_URL = `${API_ORIGIN}/api/`;

/** Public URL for files under storage/app/public (symlinked as /storage). */
export function storageUrl(path) {
  if (!path) return '#';
  const p = String(path).replace(/^\//, '');
  return `${API_ORIGIN}/storage/${p}`;
}

/** Prefer backend-signed URL (works when /storage gives 403); fallback to direct /storage/. */
export function collectionFileDisplayUrl(file) {
  if (!file || typeof file !== 'object') return '#';
  if (typeof file.access_url === 'string' && file.access_url.startsWith('http')) {
    return file.access_url;
  }
  return file.path ? storageUrl(file.path) : '#';
}

/** Same basename as React Router (`PUBLIC_URL`). */
export const ROUTER_BASENAME = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

/** Client-facing estimate link (matches Laravel `send` URL when frontend origin matches). */
export function publicClientPortalUrl(portalToken) {
  if (!portalToken) return '';
  if (typeof window === 'undefined') {
    return `${ROUTER_BASENAME}/public/client/${portalToken}`;
  }
  return `${window.location.origin}${ROUTER_BASENAME}/public/client/${portalToken}`;
}

export function publicEstimateUrl(publicToken) {
  if (!publicToken) return '';
  if (typeof window === 'undefined') {
    return `${ROUTER_BASENAME}/public/estimate/${publicToken}`;
  }
  return `${window.location.origin}${ROUTER_BASENAME}/public/estimate/${publicToken}`;
}
